const appInfo = {
  title: 'Palánta',
};
export default appInfo;
